import { formatPhoneNumber, isValidPhoneNumber, parseBookingPhone } from "./phoneNumber";

export const NOTIFICATION_DESTINATIONS = [
  { value: "return_phone", label: "Return Telephone Number" },
  { value: "patient_phone", label: "Patient Telephone Number" },
  { value: "none", label: "No SMS Notifications" },
];

export function notificationDestinationLabel(value) {
  return NOTIFICATION_DESTINATIONS.find((item) => item.value === value)?.label || "Patient Telephone Number";
}

export function patientProfilePhone(payload) {
  const sources = [payload?.result, payload?.data, payload].filter((item) => item && typeof item === "object");
  for (const source of sources) {
    const record = Array.isArray(source) ? source[0] : source;
    const value = record?.telecom?.find((item) => item?.system === "phone")?.value;
    if (typeof value !== "string") continue;
    const phone = parseBookingPhone(value).phone;
    if (isValidPhoneNumber(phone)) return phone;
  }
  return "";
}

export function notificationDestinationHelp({ destination, returnPhone, patientPhone }) {
  if (destination === "return_phone") {
    return isValidPhoneNumber(returnPhone)
      ? `Appointment texts are sent to ${formatPhoneNumber(returnPhone)}.`
      : "Appointment texts are sent to the return telephone number.";
  }
  if (destination === "none") return "No appointment texts are sent for this appointment.";
  if (patientPhone) return `Appointment texts are sent to ${formatPhoneNumber(patientPhone)} on the patient profile.`;
  if (patientPhone === "") return "No telephone number is on the patient profile. Appointment texts will not be sent.";
  return "Appointment texts are sent to the telephone number on the patient profile.";
}
